import { ComponentProps, FC } from 'react';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

const options = [
  { id: 1, label: '1-25', min: 1, max: 25 },
  { id: 2, label: '26-75', min: 26, max: 75 },
  { id: 3, label: '76-100', min: 76, max: 100 },
  { id: 4, label: '101-500', min: 101, max: 500 },
  { id: 5, label: '> 501', min: 500 },
];

interface Props
  extends Omit<ComponentProps<typeof AutocompleteElement>, 'options'> {
  disabled?: boolean;
}

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const CompanySizeAutocomplete: FC<Props> = (props) => {
  const { setValue } = useFormContext();

  return (
    <AutocompleteElement
      options={options}
      autocompleteProps={{
        disabled: props.disabled,
        onChange: (event, value) => {
          const minFieldName = `min${capitalizeFirstLetter(props.name)}`;
          const maxFieldName = `max${capitalizeFirstLetter(props.name)}`;

          setValue(props.name, value?.id);
          setValue(minFieldName, value?.min);
          setValue(maxFieldName, value?.max);
        },
        getOptionLabel: (option) => {
          if (option.label) {
            return option.label;
          }

          return options.find((c) => c.id === Number(option))?.label;
        },
      }}
      {...props}
    />
  );
};
